export enum MailingInstructionsUrlSegment {
    Client = 'client',
    Clone = 'clone',
    MailingInstruction = 'mailinginstruction',
    Party = 'party',
    PartyRole = 'partyrole',
    Query = 'query',
    Status = 'status',
}
